import { useEffect, useState } from 'react';
import { QueryStatus } from 'src/types';
import { HttpCorporateLending } from '../api/httpCorporateLending';
import { OperacionCorporateLendingViewDTO } from '../types/dto';

export const useOperacionCorporateLending = (idOperacion: number) => {
  const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle);
  const [operacion, setOperacion] = useState<OperacionCorporateLendingViewDTO>();

  useEffect(() => {
    setStatus(QueryStatus.Loading);

    HttpCorporateLending.get(idOperacion)
      .then(data => {
        setOperacion(data);
        setStatus(QueryStatus.Success);
      })
      .catch(() => setStatus(QueryStatus.Error));
  }, [idOperacion]);

  return { status, operacion };
};